import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { filterMenuItems } from '../utils/menuAccess';
import AccountMenu from './AccountMenu';
import './MainNav.css';

// Exporte : reutilise par DashboardPage.jsx pour savoir, tuile de section par
// tuile de section (Central/Rapports/...), si un staff limite a au moins un item
// autorise dedans (cf. filterMenuItems) — sinon la tuile doit disparaitre, pas
// juste emmener vers une page-grille vide.
export const navMenus = {
  Central: [
    { label: 'Suivi des ventes', path: '/sales-monitoring' },
    { label: 'Suivi Express', path: '/express-monitoring' },
    { label: 'Fermer Vente', path: '/close-sales' },
    // { label: 'Planifier des Visites', path: null },
    { label: 'Numeros gagnants', path: '/winning-numbers' },
    { label: 'Banques Connecte', path: '/banques-connecte' },
    { label: 'Verifier le Ticket', path: '/verify-ticket' },
    { label: 'Voir Parametres', path: '/see-parameters' },
    // { label: 'Envoyer Resultats', path: null },
    { label: 'Changer Password du Terminal', path: '/change-terminal-password' },
    { label: 'Nullify Ticket', path: '/nullify-ticket' },
    { label: 'Revert Nullified Ticket', path: '/revert-nullified-ticket' },
    { label: 'Paye Ticket', path: '/pay-ticket' },
  ],
  Rapports: [
    { label: 'Rapport général', path: '/rapports/general' },
    { label: 'Liste des ventes', path: '/rapports/liste-ventes' },
    { label: 'Numeros gagnants', path: '/rapports/winning-numbers' },
    { label: 'Tickets Gagnant', path: '/rapports/winning-tickets' },
    { label: 'Resume accumule', path: '/rapports/accumulated-summary' },
    { label: 'Cumul detaille', path: '/rapports/cumul-detaille' },
    { label: 'Tickets Vendus', path: '/rapports/tickets-vendus' },
    { label: 'Tickets Annulaient', path: '/rapports/tickets-annulaient' },
    { label: 'Resume de la Banque-Lottery', path: '/rapports/resume-banque-lottery' },
    { label: 'Paris gagnants', path: '/rapports/paris-gagnants' },
    { label: 'Rapport du Terminal', path: '/rapports/terminal-report' },
    { label: 'Rapport du Banque', path: '/rapports/banques-rapport' },
    // { label: "Rapport d'activite", path: null },
    // { label: 'Reporte de Grupos', path: null },
    // { label: 'Resultats par loterie', path: null },
  ],
  Controles: [
    { label: 'Parametres de loterie', path: '/controles/parametres-loterie' },
    { label: 'Numeros Controle', path: '/controles/number-control' },
    { label: 'Eliminar Parametros', path: '/controles/eliminar-parametros' },
    // { label: 'Controlee Numbers', path: null },
    // { label: 'Rapport', path: null },
    // { label: 'Rep. Parametros', path: null },
    // { label: 'Loterias', path: null },
  ],
  Securite: [
    { label: 'Limite d\'Exposition', path: '/controles/exposition' },
    { label: 'Ratio Konbinezon', path: '/securite/konbinezon-ratio' },
    { label: 'Validation Konbinezon', path: '/securite/konbinezon-validation' },
    { label: 'Pousantaj sou Borlet', path: '/securite/borlette-coverage' },
    { label: 'Pousantaj sou Maryaj', path: '/securite/maryaj-ratio' },
    { label: 'Nombre de boules par fiche', path: '/securite/max-boules' },
    { label: "Journal d'audit", path: '/securite/audit-log' },
  ],
  Parametres: [
    { label: 'Mon Compte', path: '/parametres/compte' },
    { label: 'Facturation mensuelle', path: '/parametres/facturation' },
    { label: 'Banque', path: '/parametres/banque' },
    { label: 'Recharger un Bank', path: '/parametres/recharge' },
    { label: 'Superviseurs', path: '/parametres/superviseurs' },
    { label: 'Permissions superviseur', path: '/parametres/permissions-superviseur' },
    { label: 'Utilisateurs', path: '/parametres/utilisateurs' },
    { label: 'Act/Desactiver Ventes (Manuel)', path: '/parametres/act-desactiver-ventes-manuel' },
    { label: 'Message', path: '/parametres/message' },
    { label: 'Mes Tirages', path: '/parametres/tirages' },
  ],
  Autres: [{ label: 'Messages', path: null }],
  Bonos: [
    { label: 'Autoriser paris gratuit (Marriage Gratis)', path: '/controles/marriage-gratis' },
  ],
};

const MainNav = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const { company } = useAuth();
  const navRef = useRef(null);

  // Restriction posee par un compte staff LIMITE (cree par le superadmin pour une
  // tache precise, cf. companies.models.AdminMenuPermission) actuellement "entre"
  // dans cette company — CompanyMeView renvoie `menu_keys` uniquement dans ce cas
  // (null = pas restreint : connexion normale de la company, ou superadmin non
  // limite). On ne filtre QUE quand c'est un tableau explicite.
  const menuKeys = company?.menu_keys;
  const visibleNavMenus = useMemo(() => {
    const filtered = {};
    for (const section of Object.keys(navMenus)) {
      const items = filterMenuItems(navMenus[section], menuKeys);
      if (items.length > 0) filtered[section] = items;
    }
    return filtered;
  }, [menuKeys]);

  // Ferme le menu ouvert au clic/tap en dehors de la nav — remplace l'ancien
  // onMouseLeave (qui ne marche pas au toucher et se battait avec onClick : sur
  // mobile, le tap déclenche un mouseenter simulé JUSTE avant le click, donc le
  // menu s'ouvrait puis se refermait aussitôt via le toggle "cur === item ? null
  // ...". Uniquement du clic/tap désormais, fiable sur les deux.
  useEffect(() => {
    if (!openMenu) return undefined;
    const handleOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setOpenMenu(null);
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [openMenu]);

  const renderEntries = (entries) =>
    entries.map((entry) =>
      entry.path ? (
        <Link
          key={entry.label}
          to={entry.path}
          className="dropdown-link"
          onClick={() => setOpenMenu(null)}
        >
          {entry.label}
        </Link>
      ) : (
        <span key={entry.label} className="dropdown-link dropdown-link-disabled">
          {entry.label}
        </span>
      )
    );

  return (
    <nav className="mainnav" ref={navRef}>
      <div className="mainnav-left">
        {Object.keys(visibleNavMenus).map((item) => (
          <div key={item} className="mainnav-item">
            <span
              className="mainnav-link"
              onClick={() => setOpenMenu((cur) => (cur === item ? null : item))}
            >
              {item}
            </span>
            {openMenu === item && visibleNavMenus[item].length > 0 && (
              <div className="mainnav-dropdown mainnav-dropdown-desktop">
                {renderEntries(visibleNavMenus[item])}
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Copie mobile hors de .mainnav-left (overflow-x:auto) : voir
          commentaire equivalent dans SupervisorLayout.jsx — overflow-x:auto
          seul force aussi overflow-y:auto (regle CSS standard), un dropdown
          imbrique dedans etait ouvert mais invisible/clippe a la hauteur de
          la barre de nav sur mobile. */}
      {openMenu && visibleNavMenus[openMenu]?.length > 0 && (
        <div className="mainnav-dropdown mainnav-dropdown-mobile">
          {renderEntries(visibleNavMenus[openMenu])}
        </div>
      )}
      <div className="mainnav-right">
        <span className="mainnav-username">{company ? `${company.name}/(${company.company_user?.username || company.username || ""})` : ""}</span>
        <AccountMenu />
      </div>
    </nav>
  );
};

export default MainNav;
